import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

import RequestRow from './RequestRow'
import DataTable from 'components/organisms/DataTable'
import PaginationControl from 'components/organisms/PaginationControl'

import { requestColumns } from './'

export const styles = () => ({
  root: {},
})

const PeopleRequests = ({
  data,
  classes,
  filters,
  tableLoading,
  onPageChange,
  bulkSelected,
  onBulkSelect,
  onItemSelect,
  onRequestDeny,
  selectedPeople,
  onRequestAccept,
  onTableSortClick,
}) => (
  <div className={classes.root}>
    <DataTable
      key="Request table"
      dataProvider={data}
      columns={requestColumns}
      className={classes.table}
      RowComponent={RequestRow}
      onItemSelect={onItemSelect}
      tableLoading={tableLoading}
      onSortClick={onTableSortClick}
      emptyStateTitle="It’s pretty quiet here without contributors"
      emptyStateDescription="Share an invite code with Goodnature Chirp App users and then approve them here so they can share traps with you and help maintain them."
      rowComponentProps={{
        onItemSelect,
        onRequestDeny,
        selectedPeople,
        onRequestAccept,
      }}
      headerProps={{
        bulkSelected,
        onBulkSelect,
      }}
    />
    <PaginationControl
      pagination={filters.pagination}
      onPageChange={onPageChange}
    />
  </div>
)

PeopleRequests.propTypes = {
  data: PropTypes.object,
  filters: PropTypes.object,
  tableLoading: PropTypes.bool,
  bulkSelected: PropTypes.bool,
  onPageChange: PropTypes.func,
  onItemSelect: PropTypes.func,
  onBulkSelect: PropTypes.func,
  onRequestDeny: PropTypes.func,
  onRequestAccept: PropTypes.func,
  selectedPeople: PropTypes.array,
  onTableSortClick: PropTypes.func,
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(PeopleRequests)



// WEBPACK FOOTER //
// ./src/containers/people/PeopleRequests/PeopleRequests.js